// extracted by mini-css-extract-plugin
module.exports = {"search":"_1ahHUS _2M8cLY","btnSearch":"_2eI53y L0Z3Pu","icon-search":"_2s7Xzl _34RNph"};